import { useCallback } from 'react';
import { mergePeriodRulesIntoScheduleRules } from '~/modules/resourcing/common/util/scheduleUtil';
import { getScheduleRulesForOptimisticResponse } from '~/modules/resourcing/common/util/taskAllocationSaveUtil';

export const getUpdatedTaskAllocation = ({
  taskResourceAllocation,
  periodStartDate,
  periodEndDate,
  updatedTaskAllocationPeriodHours
}) => {
  const periodScheduleRules = getScheduleRulesForOptimisticResponse({
    periodStartDate,
    periodEndDate,
    updatedTaskAllocationPeriodHours
  });

  const updatedScheduleRules = mergePeriodRulesIntoScheduleRules(
    taskResourceAllocation?.scheduleRules,
    true
  )(periodScheduleRules);

  return {
    ...taskResourceAllocation,
    scheduleRules: updatedScheduleRules
  };
};

export const useOnChangeHandlers = ({
  taskResourceUserAllocation,
  onChange,
  periodEndDate,
  periodStartDate,
  periodTaskAllocatedHours
}) => {
  const onAllocationChange = useCallback(
    updatedTaskAllocationPeriodHours => {
      const updatedAllocation = getUpdatedTaskAllocation({
        taskResourceAllocation: taskResourceUserAllocation,
        periodStartDate,
        periodEndDate,
        updatedTaskAllocationPeriodHours
      });

      onChange({
        allocation: updatedAllocation,
        periodDetails: {
          periodStartDate,
          periodEndDate,
          newPeriodTaskAllocatedHours: updatedTaskAllocationPeriodHours,
          periodTaskAllocatedHours
        }
      });
    },
    [
      taskResourceUserAllocation,
      periodStartDate,
      periodEndDate,
      onChange,
      periodTaskAllocatedHours
    ]
  );

  return {
    onAllocationChange
  };
};
